<template>
  <div class="file-cust-gid">
    <div v-for="labelSetSample in labelSetSamples" :key="labelSetSample.id" class="thumbnail-container">
      <div class="tags-overlay">
        <!-- Label object set tags -->
        <template v-if="labelSetSample.label_object_sets && labelSetSample.label_object_sets[0]">
          <b-badge
            v-for="tag in labelSetSample.label_object_sets[0].tags_data"
            :key="`lss${tag.id}`"
            class="mx-1 mb-1 label-object-set-tag"
          >
            {{ tag.name }}
          </b-badge>
        </template>
      </div>
      <FilePreview v-if="labelSetSample.files && labelSetSample.files.length" :file="labelSetSample.files[0]"
        :set_id="labelSetSample.sample_set_id" :class="{ 'selected': selectedSamples.includes(labelSetSample.id) }" @click.native="handleClick($event, labelSetSample.id)" class="no-drag">
        <router-link :to="{
          name: 'LabelSample',
          query: { filter: JSON.stringify(queryParams) },
          params: { project_id: labelSetSample.project_id, sample_id: labelSetSample.id, label_set_id: label_set_id }
        }">
          <a align-h="around"><i class="mx-1 fa fa-paint-brush fa-lg" /></a>
        </router-link>
      </FilePreview>
    </div>
  </div>
</template>
<script>
import FilePreview from '@/views/Shared/FilePreview.vue';

export default {
  props: {
    labelSetSamples: {
      value: Array,
      required: true
    },
    label_set_id: {
      type: Number,
      required: true
    },
    queryParams: {
      value: Object,
    },
    selectedSamples: {
      type: Array,
      required: true
    }
  },
  components: {
    FilePreview,
  },
  methods: {
    handleClick(event, sampleId) {
      this.$emit('toggleSelectSample', sampleId, event);
    }
  }
};
</script>

<style lang="scss" scoped>
.file-cust-gid {
  .thumbnail-container {
    position: relative;
    display: inline-block;
  }

  .tags-overlay {
    position: absolute;
    top: 8px;
    left: 8px;
    z-index: 1;
    max-width: calc(100% - 16px);
    display: flex;
    flex-wrap: wrap;
    pointer-events: none;
  }
  .selected {
    ::v-deep .image {
      border: 3px solid blue;
    }
  }
}
.no-drag {
  user-select: none;
  -webkit-user-drag: none;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;

  img {
    pointer-events: none;
    user-select: none;
    -webkit-user-drag: none;
    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
  }
}
</style>
